// Action Types
export const SUBMIT_CORPORATE_AND_ORG_STRUCTURE_REQUEST =
  "SUBMIT_CORPORATE_AND_ORG_STRUCTURE_REQUEST";
export const SUBMIT_CORPORATE_AND_ORG_STRUCTURE_SUCCESS =
  "SUBMIT_CORPORATE_AND_ORG_STRUCTURE_SUCCESS";
export const SUBMIT_CORPORATE_AND_ORG_STRUCTURE_FAILURE =
  "SUBMIT_CORPORATE_AND_ORG_STRUCTURE_FAILURE";

// Action Creators
export const submitCorporateAndOrgStructureRequest = (dimension, client) => ({
  type: SUBMIT_CORPORATE_AND_ORG_STRUCTURE_REQUEST,
  payload: { dimension, client },
});

export const submitCorporateAndOrgStructureSuccess = (message) => ({
  type: SUBMIT_CORPORATE_AND_ORG_STRUCTURE_SUCCESS,
  payload: message,
});

export const submitCorporateAndOrgStructureFailure = (error) => ({
  type: SUBMIT_CORPORATE_AND_ORG_STRUCTURE_FAILURE,
  payload: error,
});
